import { ActionIcon, Anchor, Flex, Group, Text } from '@mantine/core';
import { IconBrandFacebook, IconBrandInstagram, IconBrandLinkedin, IconBrandTiktok, IconBrandYoutube } from '@tabler/icons-react';
import React from 'react';
import appSettings from '../../appsettings.json';

const Footer: React.FC = () => {
	return (
		<Flex justify="space-between" align="center" style={{
			width: '100%',
			borderTop: '1px solid #eee',
			background: '#fff',
			boxSizing: 'border-box',
			flexWrap: 'wrap',
			gap: 16,
			overflow: 'hidden',
		}}>

			<Group style={{ minWidth: 0, flex: 1 }}>

				<Text size="xs">&copy; 2024 Conduction, Inc. All rights reserved</Text>
				<Text size="xs">Version {appSettings.Version}</Text>
				<Anchor href="https://docs.google.com/document/d/1ErgPJORWHHJrvAY8USGhaPG0Wa9AEa-O/edit?usp=sharing&ouid=115620778392196722500&rtpof=true&sd=true"
					target="blank"
					size="xs">
					COPPA Notice
				</Anchor>

			</Group>

			<Group style={{ minWidth: 0, flex: '0 1 auto', textAlign: 'center', display: 'flex', justifyContent: 'center', gap: 16 }}>

				<Anchor href="https://www.conduction.live/">About Us</Anchor>
				<Anchor>Help</Anchor>
				<Anchor href="https://app.conduction.live/login">Conduction Education</Anchor>
			</Group>


			<Group style={{ minWidth: 0, flex: 1, display: 'flex', justifyContent: 'flex-end', gap: 16 }}>

				<ActionIcon size="md" variant="default" radius="lg" component="a"
					href="https://www.instagram.com/conduction.live?igsh=MTV2cjdwbXU1djBmaQ==/"
					target="blank">
					<IconBrandInstagram size={18} stroke={1.5} />
				</ActionIcon>

				{/* add fackbook link */}
				<ActionIcon size="md" variant="default" radius="xl" component="a"
					href="https://www.facebook.com/100086203396526/about/?_rdr"
					target="blank">
					<IconBrandFacebook size={18} stroke={1.5} />
				</ActionIcon>

				<ActionIcon size="md" variant="default" radius="xl" component="a"
					href="https://www.youtube.com/@ConductionEducation"
					target="blank">
					<IconBrandYoutube size={18} stroke={1.5} />
				</ActionIcon>

				<ActionIcon size="md" variant="default" radius="xl" component="a"
					href="https://www.linkedin.com/company/conduction-live"
					target="blank">
					<IconBrandLinkedin size={18} stroke={1.5} />
				</ActionIcon>

				<ActionIcon size="md" variant="default" radius="xl" component="a"
					href="https://www.tiktok.com/@conduction.live"
					target="blank">
					<IconBrandTiktok size={18} stroke={1.5} />
				</ActionIcon>
			</Group>
		</Flex>
	);
};

export default Footer;